import { lazy } from 'react';

// Aisle Dominator
const AisleDominator = lazy(() => import('./Dashboard'));
const AisleDominatorCreate = lazy(() => import('../../components/aisle/CreationFlow'));
const AisleOverview = lazy(() => import('./Overview'));
const AisleDominatorReport = lazy(() => import('./AisleReport'));
const AisleDominatorList = lazy(() => import('./AisleList'));
const AisleDominatorSpotSelection = lazy(() => import('./SpotSelection'));
const AisleDominatorResult = lazy(() => import('./Result'));
const AisleEditDominator = lazy(() => import('./EditAisle'));
const AisleActivity = lazy(() => import('./AisleActivity'));
const AisleMarketStream = lazy(() => import('./marketstream/Main'));
const AisleMarketStreamList = lazy(() => import('./marketstream/LaunchedStreams'));
const AisleMarketStreamConfig = lazy(() => import('./marketstream/launch/Configuration'));

export default {
  AisleDominator,
  AisleDominatorCreate,
  AisleDominatorReport,
  AisleDominatorList,
  AisleDominatorSpotSelection,
  AisleDominatorResult,
  AisleEditDominator,
  AisleActivity,
  AisleOverview,
  AisleMarketStream,
  AisleMarketStreamConfig,
  AisleMarketStreamList,
};
